module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento13.89bec074.svg";